module.exports = __webpack_public_path__ + "img/contract-ok.0fcc9318.svg";